export const REDUX_STORE_PROJECT_FLOWCHART = 'PROJECT_FLOWCHART';
export const REDUX_STORE_TIMELINE_DATA = 'TIMELINE_DATA';

import { UNDOABLE_TYPE } from './enums/undoable.type.enum';
import { combineReducers } from 'redux';
import { undoable } from './undoable';
import { ProjectFlowchartState, projectFlowchartDataReducer } from '../../shared/redux/project-flowchart.store';
import { ITimelineDataState, timelineDataReducer } from '../../components/shared/interactivity-editor/redux/timeline-data.store';

export interface IAppState {
	REDUX_STORE_PROJECT_FLOWCHART: ProjectFlowchartState;
	REDUX_STORE_TIMELINE_DATA: ITimelineDataState;
}

export interface DefaultReduxState {
	data?: any;
	fromCommand?: string;
	type?: string;
	timestamp?: number;
}

export const rootReducer = combineReducers({
	PROJECT_FLOWCHART: undoable(projectFlowchartDataReducer, UNDOABLE_TYPE.PROJECT_FLOWCHART),
	TIMELINE_DATA: undoable(timelineDataReducer, UNDOABLE_TYPE.TIMELINE_DATA)
});
